import * as effects from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import * as actions from './actions'
import * as api from './api'
import history from '../../utils/history'
import { formatErrorMessage } from '../../utils/helpers'
import * as Sentry from '@sentry/react'
import { CreateCourseType } from './types'

function* createCourse(payload: CreateCourseType): SagaIterator {
  try {
    const { title, status, starts_at, auto_subscription } = payload
    yield effects.call(
      api.createCourse,
      title,
      status,
      starts_at,
      auto_subscription
    )
    yield effects.put(actions.createCourseSuccess())
    yield effects.call([history, history.push], '/admin/courses')
  } catch (error) {
    console.warn('Cannot create course', error)
    yield effects.put(actions.createCourseFailure(formatErrorMessage(error)))
    Sentry.captureException(error)
  }
}

function* watchCreateCourse(): SagaIterator {
  yield effects.takeEvery(actions.createCourse.toString(), createCourse)
}

export default function* watchAdminCourseCreate(): SagaIterator {
  yield effects.all([effects.fork(watchCreateCourse)])
}
